import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { ClientesService } from 'src/app/services/clientes.service';
import { NgbModal, NgbModalConfig } from "@ng-bootstrap/ng-bootstrap";
import { Ng2IzitoastService } from "ng2-izitoast";
import { R3ConstructorFactoryMetadata } from '@angular/compiler/src/render3/r3_factory';
import { CarrerasService } from 'src/app/services/carreras.service';
import { GruposService } from 'src/app/services/grupos.service';
import { PaquetesService } from 'src/app/services/paquetes.service';
import { ProductosService } from 'src/app/services/productos.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { ThrowStmt } from '@angular/compiler';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss'],
  providers: [NgbModalConfig, NgbModal]// add NgbModalConfig and NgbModal to the 

})
export class ClientesComponent implements OnInit {
  environment = environment.BASE_URL
  respuestaGet:any;
 clientes: any[] = []
 respuestaClientes:any;
 respuestaAgregarPagos: any;
 respuestaAgregarCliente: any;
 respuestaPaqueteCliente: any;
 respuestaMolduras: any;
 respuestaPlacas: any;
 respuestaEliminarPlaca:any;
 respuestaAgregarProductoCliente:any;
 respuestaAgregarAnotaciones:any;
 respuestaEliminarProductoCliente: any;
  pagos = []
  carreras = []
  grupos = []
  paqueteCliente;
  fechaPago = '';
  respuestaPagos:any;
  respuestaCarreras:any;
  respuestGrupos:any;
  respuestaEliminarMoldura: any;
  respuestaAgregarMoldura: any;
  respuestaAgregarPlaca: any;
  respuestaEditarCliente: any;
  respuestaUpdateCliente: any;
  respuestaPaquetes: any;
  respuestaProductos: any;
  respuestaPaqueteClienteSelected: any;
  respuestaAgregarPaqueteCliente: any;
  respuestaEliminarPaqueteCliente: any;
  respuestaInstituciones:any;
  respuestaColores:any;
  respuestaAgregarColor:any;
  respuestaEliminarColor:any;
  colores;
  paqueteClienteSelected;
  dataUsuario;
  usuarioid;
  anotaciones;
  datos_grupo;

  total;
  totalCliente;
  saldo;
  datosCliente;

  formulario;
  formulario2;
  formularioEdit
  data;
  molduras;
  placas;
  paquetes;
  productos;
  instituciones;

  clienteid;
  formularioPago;
  error;
  buscar: any;
  conceptos = [
    {'nombre':'Agradecimiento', 'detalle':'Dedicatoria 1'},
    {'nombre':'Moldura', 'detalle':'Guitarra - Chocolate'},
    {'nombre':'Placa', 'detalle':'España'},
    {'nombre':'Anillo', 'detalle':'Mod. 029'},
  ]

  p: number = 1;
  closeResult: string;

  filtro;

  keyword = 'nombre';

  @ViewChild(DataTableDirective, {static:false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  dataCliente:any;

  constructor(private modalService: NgbModal, private _getClientes:ClientesService, private _getPagos:ClientesService,
    private _agregarPago: ClientesService, public iziToast: Ng2IzitoastService, private _agregarCliente : ClientesService,
    private _getCarreras: CarrerasService, private _getGrupos: GruposService, private _getPaqueteCliente: ClientesService,
    private _getMolduras: ClientesService, private _getPlacas: ClientesService, private _eliminarPlaca: ClientesService,
    private _eliminarMoldura: ClientesService, private _agregarMoldura: ClientesService, private _agregarPlaca: ClientesService,
    private _editarCliente:ClientesService, private _updateCliente: ClientesService, private _getPaquetes: PaquetesService,
    private _getProductos: ProductosService, private _agregarPaqueteCliente: ClientesService, private _getInstituciones: CarrerasService,
    private _getPaqueteClienteSelected:ClientesService, private _eliminarPaqueteCliente:ClientesService,
    private _agregarProductoCliente: ClientesService, private _eliminarProductoCliente:ClientesService,
    private _getColores: ClientesService, private _agregarColor: ClientesService, private _eliminarColorCliente: ClientesService, 
    private _agregarAnotaciones: ClientesService, private _getData:LoginService,) { }

  ngOnInit(): void {

    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      pageLength: 30,
      processing: true
    };

    this.getClientes();
    this.getGrupos();
    this.getMolduras();
    this.getPlacas();
    this.getProductos();
    this.getPaquetes();
    this.getColores();

    this.formulario = {
      monto: '',
      usuarioid: ''
    }

    this.formulario2 = {
      nombre:'',
      apellidos:'',
      apellido_materno: '',
      celular:'',
      email:'',
      monto_compra:'',
      grupo: '',
    }

    this.formularioEdit = {
      nombre:'',
      apellidos:'',
      apellido_materno: '',
      celular:'',
      email:'',
      monto_compra:''
    }

    this.anotaciones = {
      texto: '',
    }

    this.formularioPago = {
      tipo_pago: '',
      folio: '',
    }

    this._getCarreras.getCarreras().subscribe(
      data => {
        this.respuestaCarreras = data;
        if(this.respuestaCarreras.success){
          this.carreras = this.respuestaCarreras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
    this.getInstituciones();

    this.filtro = {
      'grupo':'',
      'alumno':'',
      'apellidos':'',
    }

    this.getDataCliente();
  }

  getDataCliente(){
    this._getData.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.dataCliente = this.respuestaGet.content;
        
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }


  getInstituciones(){
    this._getInstituciones.getInstituciones().subscribe(
      data => {
        this.respuestaInstituciones = data;
        if(this.respuestaInstituciones.success){
          this.instituciones = this.respuestaInstituciones.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
    
  }

  getMolduras(){
    this._getMolduras.getMolduras().subscribe(
      data => {
        this.respuestaMolduras = data;
        if(this.respuestaMolduras.success){
          this.molduras = this.respuestaMolduras.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPlacas(){
    this._getPlacas.getPlacas().subscribe(
      data => {
        this.respuestaPlacas = data;
        if(this.respuestaPlacas.success){
          this.placas = this.respuestaPlacas.content;
          console.log(this.placas);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPaquetes(){
    this._getPaquetes.getPaquetes().subscribe(
      data => {
        this.respuestaPaquetes = data;
        if(this.respuestaPaquetes.success){
          this.paquetes = this.respuestaPaquetes.content;
          console.log(this.paquetes);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getProductos(){
    this._getProductos.getProductos().subscribe(
      data => {
        this.respuestaProductos = data;
        if(this.respuestaProductos.success){
          this.productos = this.respuestaProductos.content;
          console.log(this.productos);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getColores(){
    this._getColores.getColores().subscribe(
      data => {
        this.respuestaColores = data;
        if(this.respuestaColores.success){
          this.colores = this.respuestaColores.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getClientes(){
    this._getClientes.getClientes().subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
          // this.dtTrigger.next();
          // this.dtTrigger.unsubscribe();

        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }


  getClientesFiltro(idGrupoSelect){
    this.data = {
      'grupo':idGrupoSelect,
    }
    this._getClientes.getClientesFiltro(this.data).subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
          // this.dtTrigger.unsubscribe();
          // this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  getClientesFiltroText(){
    this.data = {
      'alumno':this.filtro.alumno,
      'apellidos':this.filtro.apellidos,
    }
    this._getClientes.getClientesFiltroText(this.data).subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
          // this.dtTrigger.unsubscribe();
          // this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  getGrupos(){
    this._getGrupos.getGruposNombre().subscribe(
      data => {
        this.respuestGrupos = data;
        if(this.respuestGrupos.success){
          this.grupos = this.respuestGrupos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getPagos(idusuario){
    this.dataUsuario = {
      'usuario':idusuario
    }
    this._getPagos.getPagos(this.dataUsuario).subscribe(
      data => {
        this.respuestaPagos = data;
        if(this.respuestaPagos.success){
          this.pagos = this.respuestaPagos.content;
          this.total = this.respuestaPagos.total;
          this.totalCliente = this.respuestaPagos.compraMonto;
          this.saldo = this.respuestaPagos.saldo;
          this.usuarioid = this.respuestaPagos.usuarioid;
          this.datos_grupo = this.respuestaPagos.datos_pagos;
          document.getElementById('click').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarPago(dataid, forma_pago){

    if (this.formulario.fecha != null){
      this.fechaPago = this.formulario.fecha['year']+'-'+this.formulario.fecha['month']+'-'+this.formulario.fecha['day']
    }
    this.data = {
      'pago': this.formulario.monto,
      'folio': this.formulario.folio,
      'forma_pago':forma_pago,
      'usuario': dataid,
      'tipo_pago':this.formularioPago.tipo_pago,
      'fecha':this.fechaPago,
    }
    
    this._agregarPago.agregarPago(this.data).subscribe(
      data => {
        this.respuestaAgregarPagos = data;
        if(this.respuestaPagos.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.folio = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getClientes();
          this.getPagos(dataid);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarUsuario(){
    this.data = {
      // 'carrera': carrera,
      'grupo': this.formulario2.grupo,
      'first_name': this.formulario2.nombre,
      'last_name': this.formulario2.apellidos,
      'apellido_materno': this.formulario2.apellido_materno,
      'celular': this.formulario2.celular,
      'username': this.formulario2.celular,
      'email': this.formulario2.email,
      'password': this.formulario2.celular,
      // 'monto_compra': this.formulario2.monto_compra
    }

    if (this.formulario2.celular != ''){
      this._agregarCliente.agregarCliente(this.data).subscribe(
        data => {
          this.respuestaAgregarCliente = data;
          if(this.respuestaAgregarCliente.success){
            this.iziToast.show(
              {
                  title: 'Se ha agregado el cliente correctamente.',
                  titleColor: '#f8f8ff',
                  color: '#4CAF50',
                  position: 'topRight',
                  closeOnEscape: true,
              });
            this.formulario2.nombre = '';
            this.formulario2.apellidos = '';
            this.formulario2.celular = '';
            this.formulario2.email = '';
            this.dtTrigger.unsubscribe();
            this.dismissAll();
            this.getClientes();
          }else {
            this.iziToast.show(
              {
                  title: this.respuestaAgregarCliente.error,
                  titleColor: '#ffffff',
                  color: '#CA0B00',
                  position: 'topRight',
                  closeOnEscape: true,
              });
            // alert('No se cargaron los datos');
          }
        }, error => console.error(error));
    }else{
      this.iziToast.show(
        {
            title: 'Por favor agrega un número telefónico.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
    }
    
  }

  getPaqueteCliente(cliente){
    this.data = {
      'cliente':cliente
    }

    this._getPaqueteCliente.getPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaPaqueteCliente = data;
        if(this.respuestaPaqueteCliente.success){
          this.paqueteCliente = this.respuestaPaqueteCliente.content;
          this.clienteid = cliente;
          document.getElementById('clickPaquete').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  getPaqueteClienteSelected(cliente){
    this.data = {
      'cliente':cliente
    }

    this._getPaqueteClienteSelected.getPaqueteClienteSelected(this.data).subscribe(
      data => {
        this.respuestaPaqueteClienteSelected = data;
        if(this.respuestaPaqueteClienteSelected.success){
          this.paqueteClienteSelected = this.respuestaPaqueteCliente.content;
          this.clienteid = cliente;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarPlaca(placa, cliente){
    console.log(placa);
    this.data = {
        'placa':placa
    }

    this._eliminarPlaca.eliminarPlaca(this.data).subscribe(
      data => {
        this.respuestaEliminarPlaca = data;
        if(this.respuestaEliminarPlaca.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarMoldura(moldura, cliente){
    console.log(moldura);
    this.data = {
        'moldura':moldura
    }

    this._eliminarMoldura.eliminarMoldura(this.data).subscribe(
      data => {
        this.respuestaEliminarMoldura = data;
        if(this.respuestaEliminarMoldura.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarPaqueteCliente(paquete, cliente){
    this.data = {
      'paqueteCliente':paquete
    }

    this._eliminarPaqueteCliente.eliminarPaqueteCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarPaqueteCliente = data;
        if(this.respuestaEliminarPaqueteCliente.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarProductoCliente(producto, cliente){
    this.data = {
      'productoCliente':producto
    }

    this._eliminarProductoCliente.eliminarProductoCliente(this.data).subscribe(
      data => {
        this.respuestaEliminarProductoCliente = data;
        if(this.respuestaEliminarProductoCliente.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarMoldura(moldura, cliente){
    this.data = {
        'moldura':moldura, 
        'usuario':cliente
    }

    this._agregarMoldura.agregarMolduraUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarMoldura = data;
        if(this.respuestaAgregarMoldura.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarProductoCliente(producto, cliente){
    this.data = {
        'producto':producto, 
        'cliente':cliente
    }

    this._agregarProductoCliente.agregarProductoCliente(this.data).subscribe(
      data => {
        this.respuestaAgregarProductoCliente = data;
        if(this.respuestaAgregarProductoCliente.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarPlaca(placa, cliente){
    this.data = {
        'placa':placa, 
        'usuario':cliente
    }

    this._agregarPlaca.agregarPlacaUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarPlaca = data;
        if(this.respuestaAgregarPlaca.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarColor(color, cliente){
    this.data = {
      'color':color, 
      'cliente':cliente
  }

    this._agregarColor.agregarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaAgregarColor = data;
        if(this.respuestaAgregarColor.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  eliminarColorCliente(color, cliente){
    this.data = {
      'color':color
    }

    this._eliminarColorCliente.eliminarColorUsuario(this.data).subscribe(
      data => {
        this.respuestaEliminarColor = data;
        if(this.respuestaEliminarColor.success){
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  agregarPaqueteCliente(paquete, cliente){
    this.data = {
      'paquete':paquete, 
      'cliente':cliente
  }

  this._agregarPaqueteCliente.agregarPaqueteCliente(this.data).subscribe(
    data => {
      this.respuestaAgregarPaqueteCliente = data;
      if(this.respuestaAgregarPaqueteCliente.success){
        this.dismissAll();
        this.getPaqueteCliente(cliente);
      }else {
        alert('No se cargaron los datos');
      }
    }, error => console.error(error)
  )
  }

  editarCliente(cliente){
    console.log('entra')
    this.data = {
      'cliente':cliente,
    }
    this._editarCliente.editarCliente(this.data).subscribe(
      data => {
        this.respuestaEditarCliente = data;
        if(this.respuestaEditarCliente.success){
          this.datosCliente = this.respuestaEditarCliente.content;
          this.dismissAll();
          this.formularioEdit.nombre = this.datosCliente.nombre;
          this.formularioEdit.apellidos = this.datosCliente.apellidos;
          this.formularioEdit.apellido_materno = this.datosCliente.apellido_materno;
          this.formularioEdit.celular = this.datosCliente.celular;
          this.formularioEdit.email = this.datosCliente.email;
          this.formularioEdit.monto_compra = this.datosCliente.monto_compra;
          this.formularioEdit.grupo = this.datosCliente.grupo;
          this.clienteid = cliente;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }

  updateCliente(cliente){
    if(this.formularioEdit.password != undefined){
      this.data = {
        'usuario': cliente, 
        'first_name': this.formularioEdit.nombre,
        'last_name': this.formularioEdit.apellidos,
        'apellido_materno': this.formularioEdit.apellido_materno,
        'celular': this.formularioEdit.celular,
        'email': this.formularioEdit.email,
        'grupo': this.formularioEdit.grupo,
        'password': this.formularioEdit.password,
      }
    }else{
      this.data = {
        'usuario': cliente, 
        'first_name': this.formularioEdit.nombre,
        'last_name': this.formularioEdit.apellidos,
        'apellido_materno': this.formularioEdit.apellido_materno,
        'celular': this.formularioEdit.celular,
        'email': this.formularioEdit.email,
        'grupo': this.formularioEdit.grupo,
        'password': '',
      }

    }
    

    this._updateCliente.updateCliente(this.data).subscribe(
      data => {
        this.respuestaUpdateCliente = data;
        if(this.respuestaUpdateCliente.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getClientes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarAnotaciones(cliente){
    this.data = {
      'texto': this.anotaciones.texto,
      'cliente':cliente,
    }

    this._agregarAnotaciones.agregarAnotaciones(this.data).subscribe(
      data => {
        this.respuestaAgregarAnotaciones = data;
        if(this.respuestaAgregarAnotaciones.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado la anotación correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.anotaciones.texto = '';
          this.dismissAll();
          this.getPaqueteCliente(cliente);
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  selectEvent(item) {
    console.log(item.id);
    var idGrupoSelect = item.id
    this.getClientesFiltro(idGrupoSelect)
    // do something with selected item
  }

  selectEvent2(item) {
    this.formulario2.grupo = item.id
    // do something with selected item
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onChangeSearch2(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }
  
  onFocused(e){
    // do something when input is focused
  }

  onFocused2(e){
    // do something when input is focused
  }
  


  eliminarCliente(cliente){
    this.data = {
      'cliente':cliente
    }

    this._updateCliente.eliminarCliente(this.data).subscribe(
      data => {
        this.respuestaUpdateCliente = data;
        if(this.respuestaUpdateCliente.success){
          this.iziToast.show(
            {
                title: 'Se ha eliminado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.getClientes();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
 
  search(){
    this.clientes.filter(res =>{
      return res.nombre.toLocaleLowerCase().match(this.buscar)
    })
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
